import { Links, Meta, Outlet, Scripts, ScrollRestoration } from 'react-router'
import stylesheet from '@/app.css?url'
import { Providers } from '@/components/Providers'
import { RouteErrorFallback } from '@/modules/errors'

export function links() {
  return [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossOrigin: 'anonymous' as const,
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Fira+Code:wght@400;500&display=swap',
    },
    { rel: 'stylesheet', href: stylesheet },
  ]
}



export default function Root() {
  
  const THEME_SCRIPT = `(function(){try{if(localStorage.getItem('theme')==='light'){document.documentElement.classList.remove('dark')}}catch(e){}})()`
  
  return (
    <html lang='en' className='h-full dark' suppressHydrationWarning>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <Meta />
        <Links />
      </head>
      <body className='h-full antialiased'>
        <Providers>
          <Outlet />
        </Providers>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  )
}

export function ErrorBoundary() {
  return (
    <html lang='en' className='h-full'>
      <head>
        <meta charSet='utf-8' />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <Meta />
        <Links />
      </head>
      <body className='h-full antialiased'>
        <RouteErrorFallback />
        <Scripts />
      </body>
    </html>
  )
}
